import type { FC } from 'react'

type AddressT = {
  nameOrNumber: string | null
  line1: string | null
  line2: string | null
  line3: string | null
  city: string | null
  county: string | null
  postcode: string | null
  country: string | null
}

const Address: FC<AddressT> = ({
  nameOrNumber,
  line1,
  line2,
  line3,
  city,
  county,
  postcode,
  country,
}) => (
  <div>
    <div>{nameOrNumber}</div>
    <div>{line1}</div>
    <div>{line2}</div>
    <div>{line3}</div>
    <div>{city}</div>
    <div>{county}</div>
    <div>{postcode}</div>
    <div>{country}</div>
  </div>
)

export default Address
